export const initialPopUpMessage = {
    message: '',
    isVisible: false,
};
